import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex",
    paddingTop: 2,
    paddingBottom: 2,
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    justifyContent: "flex-start",
    letterSpacing: "0.01em",
    padding: "9px 14px",
    textTransform: "none",
    width: "100%",
    borderRadius: 8,
    transition: "background-color 0.18s ease, color 0.18s ease",
    "&:hover": {
      backgroundColor: "rgba(233, 58, 36, 0.07)",
      color: theme.palette.primary.main,
      "& $icon": {
        color: theme.palette.primary.main,
        opacity: 1,
      },
    },
  },
  icon: {
    marginRight: theme.spacing(1.5),
    opacity: 0.6,
    transition: "color 0.18s ease, opacity 0.18s ease",
  },
  title: {
    marginRight: "auto",
    fontSize: "0.875rem",
  },
  active: {
    color: theme.palette.primary.main,
    backgroundColor: "rgba(233, 58, 36, 0.09)",
    "&:hover": {
      backgroundColor: "rgba(233, 58, 36, 0.13)",
    },
    "& $title": {
      fontWeight: 600,
    },
    "& $icon": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
  },
}));

const NavItem = ({ className, href, icon: Icon, title, onClick, ...rest }) => {
  const classes = useStyles();

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      <Button
        activeClassName={classes.active}
        className={classes.button}
        component={RouterLink}
        onClick={onClick}
        to={href}
      >
        {Icon && <Icon className={classes.icon} size="20" />}
        <span className={classes.title}>{title}</span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavItem;
